export default "__VITE_ASSET__DYqWIgKv__"